import Client from "../shared/services/Client";

function getPromoCodeInfo(promoCode: string): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    return Client.get(`/api/promo-codes/${ encodeURIComponent(promoCode) }`);
}

export default {
    getPromoCodeInfo
};
